<!-- 通知和新闻列表 -->
<template>
  <div id="noticeList">
    <headerVue></headerVue>
    <div class="container">
      <!-- 通知列表 -->
      <div class="center">
        <div class="content" v-for="item in noticeList" :key="item.id">
          <img src="../../assets/image/picture/icon_local1.png" />
          <div class="title" @click="toDetail(item.id)">{{ item.title }}</div>
          <span>{{
            item.createTime.substr(0, item.createTime.length - 3)
          }}</span>
        </div>
      </div>
      <!-- 分页 -->
      <el-pagination
        class="page"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 16px;float: right;margin-right: 10px;"
        :total="total"
        :page-sizes="[10]"
        :page-size="query.pageSize"
        :current-page="query.currentPage"
        @size-change="changePageSize"
        @current-change="currentPage"
      >
      </el-pagination>
    </div>
    <footerVue></footerVue>
  </div>
</template>

<script>
import headerVue from "../index/header.vue";
import footerVue from "../foot/foot.vue";
export default {
  name: "noticeList",
  data() {
    return {
      noticeList: [],
      total: 0,
      // 分页
      pageData: {
        // 一页几条
        pageSize: 10,
        // 当前页数
        currentPage: 1,
      },
      query: {
        // 当前页数
        currentPage: 1,
        // 一页几条
        pageSize: 10,
      },
    };
  },
  created() {
    this.getNoticeList();
  },
  methods: {
    // 跳转至通知详情
    async toDetail(_id) {
      this.$router.push(`/noticeDetail?tm=${_id}`)
      // this.$router.push({ name: "routeNoticeDetail", params: { id: _id } });
    },
    async getNoticeList() {
      let res = await this.$api.nav.getNoticeList(
        this.query.currentPage,
        this.query.pageSize
      );
      // console.log(res);
      this.noticeList = res.data.rows;
      this.total = res.data.total;
      // console.log(this.noticeList);
    },
    // args是默认参数，表示一页多少条
    changePageSize(args) {
      // console.log(args)
      this.pageData.pageSize = args;
      this.query.pageSize = args;
      // 重新更新页面
      this.getNoticeList();
    },
    // args是默认参数，表示当前是第几页
    currentPage(args) {
      // console.log(args)
      this.pageData.currentPage = args;
      this.query.currentPage = args;
      this.getNoticeList();
    },
  },
  components: {
    headerVue,
    footerVue,
  },
};
</script>

<style lang="scss" scoped>
#noticeList {
  background-color: #f5f5f5;
}

.container {
  background-color: white !important;
  padding: 10px 0px;
  margin-top: 20px;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;

  .center {
    .content {
      display: flex;
      align-items: center;
      padding: 17px;
      border-bottom: 1px solid #f0f0f0;
      position: relative;

      img {
        margin-right: 10px;
      }

      .title {
        width: 970px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      span {
        position: absolute;
        right: 0px;
        padding-right: 20px;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
.content:hover .title {
  color: #3181d1;
  transition: all 0.5s linear;
  cursor: pointer;
}


.el-pagination .el-select .el-input .el-input__inner {
  padding-right: 10px;
}
.el-input__suffix {
  display: none;
}
</style>